import { useMutation as u } from "@tanstack/react-query";
import { useAuthStore as i, authService as s, updateAuthState as h } from "@waitroom/auth";
import { hostOptInMutation as p, getRequestData as f } from "@waitroom/react-query";
const T = ({
  onSuccess: t
}) => {
  const { accessToken: a } = i();
  return u({
    ...p({
      accessToken: a
    }),
    onSuccess: async (e) => {
      const { authToken: o, refreshToken: n } = f(e) || {};
      if (!o) return;
      const r = await s.setup({
        accessToken: o,
        refreshToken: n
      });
      r.isAuthenticated && (h(r), t == null || t(e));
    }
  });
};
export {
  T as useHostOptIn
};
